import { INVALID_PASSWORD_CONFIRM } from "@/constants/invalids";
import { validator } from "@/utils/validator";

export const registerSchema = validator.object().shape({
  externalId: validator.string().trim().emptyToNull().autoTransformToHalfWidth().label("組織ID").required(),
  email: validator.string().trim().emptyToNull().autoTransformToHalfWidth().label("メールアドレス").required(),
  newPassword: validator.string().trim().emptyToNull().autoTransformToHalfWidth().strongPassword().label("パスワード").required(),
  confirmNewPassword: validator
    .string()
    .trim()
    .autoTransformToHalfWidth()
    .oneOf([validator.ref("newPassword")], INVALID_PASSWORD_CONFIRM)
    .label("パスワード（確認用）")
    .required(),
});
